import "core-js/modules/es.array.push.js";
import axios from "axios";
import { inject } from "vue";
import { mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      categoryMap: {
        rolls: "Роллы",
        sushi: "Суши",
        sets: "Сеты",
        snacks: "Боулы",
        drinks: "Напитки",
        rollsq: "Соусы"
      },
      category: null,
      limit: 8,
      isLoading: false,
      isAllLoading: false,
      total: 0,
      filters: {
        selectSort: "-price",
        filter_1: this.$route.params.category === "drinks" ? false : true,
        filter_2: false,
        filter_3: false,
        ingredients_1: this.$route.params.category === "drinks" ? false : true,
        ingredients_2: false,
        ingredients_3: this.$route.params.category === "drinks" ? false : true,
        ingredients_4: this.$route.params.category === "drinks" ? false : true,
        ingredients_5: false,
        ingredients_6: false,
        ingredients_7: false,
        ingredients_8: false,
        ingredients_9: false
      },
      sortOptions: [{
        value: "title",
        name: "По названию"
      }, {
        value: "price",
        name: "От дешевых к дорогим"
      }, {
        value: "-price",
        name: "От дорогих к дешевым"
      }],
      ingredients: [{
        id: 1,
        color: "#E86853",
        name: "лосось",
        imgUrl: require("@/img/ingredients/ingredients-1.png")
      }, {
        id: 2,
        color: "#D57E3D",
        name: "угорь",
        imgUrl: require("@/img/ingredients/ingredients-2.png")
      }, {
        id: 3,
        color: "#df394a",
        name: "тунец",
        imgUrl: require("@/img/ingredients/ingredients-3.png")
      }, {
        id: 4,
        color: "#FDA49A",
        name: "куриное филе",
        imgUrl: require("@/img/ingredients/ingredients-4.png")
      }, {
        id: 5,
        color: "#D8CC88",
        name: "тофу",
        imgUrl: require("@/img/ingredients/ingredients-5.png")
      }, {
        id: 6,
        color: "#eddac2",
        name: "сливочный сыр",
        imgUrl: require("@/img/ingredients/ingredients-6.png")
      }, {
        id: 7,
        color: "#5FD63A",
        name: "авокадо",
        imgUrl: require("@/img/ingredients/ingredients-7.png")
      }, {
        id: 8,
        color: "#c41c07",
        name: "помидор",
        imgUrl: require("@/img/ingredients/ingredients-8.png")
      }, {
        id: 9,
        color: "#916d43",
        name: "гриб шитаки",
        imgUrl: require("@/img/ingredients/ingredients-9.png")
      }],
      dialogVisible: false
    };
  },
  components: {},
  computed: {
    paths() {
      return [{
        name: this.categoryMap[this.category],
        path: this.$route.params
      }];
    },
    countIngredients() {
      return Object.keys(this.filters).filter(key => key.startsWith('ingredients_') && this.filters[key]).length;
    }
  },
  methods: {
    ...mapActions({
      addToFavorite: "favorite/addToFavorite"
    }),
    ...mapMutations({
      setPaths: "crumbs/setPaths"
    }),
    async fetchItems(name) {
      let apiRes = null;
      try {
        this.isLoading = true;
        const params = {
          page: 1,
          limit: this.limit,
          filter_1: this.filters.filter_1 ? true : undefined,
          filter_2: this.filters.filter_2 ? true : undefined,
          filter_3: this.filters.filter_3 ? true : undefined,
          "ingridients.1": this.filters.ingredients_1 ? 1 : undefined,
          "ingridients.2": this.filters.ingredients_2 ? 1 : undefined,
          "ingridients.3": this.filters.ingredients_3 ? 1 : undefined,
          "ingridients.4": this.filters.ingredients_4 ? 1 : undefined,
          "ingridients.5": this.filters.ingredients_5 ? 1 : undefined,
          "ingridients.6": this.filters.ingredients_6 ? 1 : undefined,
          "ingridients.7": this.filters.ingredients_7 ? 1 : undefined,
          "ingridients.8": this.filters.ingredients_8 ? 1 : undefined,
          "ingridients.9": this.filters.ingredients_9 ? 1 : undefined,
          sortBy: this.filters.selectSort,
          category: this.category
        };
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/items`, {
          params
        });

        // Всего результатов
        this.total = data.meta.total_items;
        this.categores = data.items.map(obj => ({
          ...obj,
          isFavorite: false,
          favoriteId: null,
          isAdded: false,
          count: 1
        }));
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        this.isLoading = false;
        if (apiRes == 404) {
          this.$router.push('/rol-shop/404');
        }
      }
    },
    async fetchFavorites() {
      let apiRes = null;
      try {
        const {
          data: favorites
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/favorites`);
        this.categores = this.categores.map(item => {
          const favorite = favorites.find(favorite => favorite.item_id === item.id);
          if (!favorite) {
            return item;
          }
          return {
            ...item,
            isFavorite: true,
            favoriteId: favorite.id
          };
        });
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        if (apiRes == 404) {
          this.$router.push('/rol-shop/404');
        }
      }
    },
    load(name) {
      this.fetchItems(name).then(() => {
        // включение кнопки для карточек
        this.categores = this.categores.map(item => ({
          ...item,
          isAdded: this.cart.some(cartItem => cartItem.id === item.id)
        }));
        this.fetchFavorites();
      });
      this.isAllLoading = false;
    },
    async loadMoreCategory() {
      let apiRes = null;
      try {
        let allItemsLoaded = false;
        let page = 1;
        while (!allItemsLoaded) {
          page += 1;
          const params = {
            page: page,
            limit: this.limit,
            filter_1: this.filters.filter_1 ? 1 : undefined,
            filter_2: this.filters.filter_2 ? 1 : undefined,
            filter_3: this.filters.filter_3 ? 1 : undefined,
            "ingridients.1": this.filters.ingredients_1 ? 1 : undefined,
            "ingridients.2": this.filters.ingredients_2 ? 1 : undefined,
            "ingridients.3": this.filters.ingredients_3 ? 1 : undefined,
            "ingridients.4": this.filters.ingredients_4 ? 1 : undefined,
            "ingridients.5": this.filters.ingredients_5 ? 1 : undefined,
            "ingridients.6": this.filters.ingredients_6 ? 1 : undefined,
            "ingridients.7": this.filters.ingredients_7 ? 1 : undefined,
            "ingridients.8": this.filters.ingredients_8 ? 1 : undefined,
            "ingridients.9": this.filters.ingredients_9 ? 1 : undefined,
            sortBy: this.filters.selectSort,
            category: this.category
          };
          const {
            data
          } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/items`, {
            params
          });
          this.categores = this.categores.concat(data.items.map(obj => ({
            ...obj,
            isFavorite: false,
            favoriteId: null,
            isAdded: false,
            count: 1
          })));
          if (data.meta.remaining_count == 0) {
            allItemsLoaded = true;
            this.categores = this.categores.map(item => ({
              ...item,
              isAdded: this.cart.some(cartItem => cartItem.id === item.id)
            }));
            this.fetchFavorites();
          }
        }
        this.isAllLoading = true;
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        if (apiRes == 404) {
          this.$router.push('/rol-shop/404');
        }
      }
    },
    showDialog() {
      this.dialogVisible = true;
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    resetIngredients() {
      for (let key in this.filters) {
        if (key.startsWith("ingredients_")) {
          this.filters[key] = false;
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.category = to.params.category;
      vm.setPaths(vm.paths);
    });
  },
  beforeRouteUpdate(to, from, next) {
    // обновление категории
    this.category = to.params.category;
    // обновление crumbs
    this.setPaths(this.paths);
    // отключение фильтров для напитков
    this.filters.filter_1 = this.category === "drinks" ? false : true;
    this.filters.ingredients_1 = this.category === "drinks" ? false : true;
    this.filters.ingredients_3 = this.category === "drinks" ? false : true;
    this.filters.ingredients_4 = this.category === "drinks" ? false : true;
    this.load();
    next();
  },
  mounted() {
    this.load();
  },
  watch: {
    // глобальное слежение
    filters: {
      handler() {
        this.load();
      },
      deep: true
    }
  },
  setup() {
    const {
      categores
    } = inject("items");
    const {
      cart,
      addToCart,
      removeFromCart
    } = inject("cart");
    const onClickAddPlus = item => {
      if (!item.isAdded) {
        addToCart(item);
      } else {
        removeFromCart(item);
        // карточка category
        categores.value.forEach(pl => {
          if (pl.id === item.id) {
            pl.isAdded = false;
            pl.count = 1;
          }
        });
      }
    };
    return {
      cart,
      onClickAddPlus,
      categores
    };
  }
};